import { render } from "./test.vue?vue&type=template&id=3f6d13a5"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=3f6d13a5&lang=css"

import exportComponent from "C:\\Users\\home\\Documents\\GitHub\\childu_usersite\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__